module.exports = __webpack_public_path__ + "img/logo_rz.603a24c8.png";